'use client';

import { useComputedColorScheme } from '@mantine/core';
import { useEffect, useMemo, useState } from 'react';

export function useStableColorScheme(defaultScheme: 'light' | 'dark' = 'dark') {
  const computedColorScheme = useComputedColorScheme(defaultScheme, {
    getInitialValueInEffect: true,
  });
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return useMemo(
    () => (mounted ? computedColorScheme : defaultScheme),
    [computedColorScheme, defaultScheme, mounted],
  );
}
